var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Banner"},[_c('div',{staticClass:"Banner_content",class:[_vm.terminal == 'pc'?'pcBanner':'phoneBanner']},[_c('div',{staticClass:"Banner_content_test"},[_c('InputCom')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }